import React from 'react';
import { useNavDrawer } from '../../contexts/NavDrawerContext';
import { useLanguage } from '../../contexts/LanguageContext';
type MenuButtonProps = {
  className?: string;
  /** Invisible hotspot over artwork that already draws the icon. */
  hotspot?: boolean;
  style?: React.CSSProperties;
};
export function MenuButton({
  className = '',
  hotspot = false,
  style
}: MenuButtonProps) {
  const {
    open,
    isOpen
  } = useNavDrawer();
  const {
    lang
  } = useLanguage();
  return <button type="button" onClick={e => open(e.currentTarget)} aria-label={lang === 'es' ? 'Abrir menú de navegación' : 'Open navigation menu'} aria-expanded={isOpen} aria-controls="site-nav-drawer" aria-haspopup="dialog" style={style} className={`flex items-center justify-center rounded-md text-white transition-colors duration-150 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ice ${hotspot ? 'hover:bg-white/10' : 'h-11 w-11 hover:bg-white/10'} ${className}`} data-id="element-474" data-mp="hm9wyuas4kye">
      {!hotspot && <span className="flex w-[22px] flex-col gap-[6px]" aria-hidden data-id="element-475" data-mp="3kh4frozvtkzl">
          <span className="h-[1.5px] w-full rounded-full bg-current" data-id="element-476" data-mp="3kifkps52cysa" />
          <span className="h-[1.5px] w-full rounded-full bg-current" data-id="element-477" data-mp="36qr4bcns7o5i" />
          <span className="h-[1.5px] w-full rounded-full bg-current" data-id="element-478" data-mp="3art9090gwsev" />
        </span>}
    </button>;
}